import { createFileRoute } from '@tanstack/react-router';

import { ExerciseCatalogList } from '@/features/exercises/components/ExerciseCatalogList';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/exercises/')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: WorkspaceExercisesCatalogScreen,
  staticData: { crumb: 'Exercises' },
});

function WorkspaceExercisesCatalogScreen() {
  return <ExerciseCatalogList surface="workspace" />;
}
